import { Component, OnInit } from '@angular/core';
import { ValidacionPcService } from '../../services/validacionPC/validacion-pc.service';
import { ESTADO_VALID_CPU } from '../../model/estadoValidCPU';


@Component({
  selector: 'app-valid-pc',
  templateUrl: './valid-pc.component.html',
  styleUrls: ['./valid-pc.component.css'],
  providers: [ValidacionPcService]
})
export class ValidPCComponent implements OnInit {
  
  public listRequirement: IRequirement[] = [];
  public ESTADO_VALID_CPU  = ESTADO_VALID_CPU;
  public speedTest = 0;
  
  constructor(public validacionPcService: ValidacionPcService) { }
  
  ngOnInit() {
    document.addEventListener('keyup', (evt) => { this.keyBoard() })
  }
  
  ngAfterViewInit(){
    this.validAll();
  }

  public setMouse(flag: Boolean){
    localStorage.setItem("mouse", flag+"");
  }

  public setTeclado(flag: Boolean){
    localStorage.setItem("teclado", flag+"");
  }

  public finishAll(){
    return this.validacionPcService.finishAllProcess();
  }

  public mouseMove() {
    this.validacionPcService.mouse = true;
    this.setMouse(true)
  }

  public keyBoard(){
    this.validacionPcService.teclado = true;
    this.setTeclado(true)
  }

  public validAll(){
    this.validacionPcService.showValid();
    let validaItem = this.validacionPcService.validCPU();
    this.listRequirement.push(
      this.getItemRequirement("Procesador", validaItem,
        this.validacionPcService.cpuSpeed + "",
        "1.4 GHZ","2 GHZ","GHZ"));

    validaItem = this.validacionPcService.validRAM();
    this.listRequirement.push(
      this.getItemRequirement("Memoria RAM", validaItem,
        this.validacionPcService.ram + "",
        "2 GB","2 GB","GB"));

    validaItem = this.validacionPcService.validDiskFree();
    this.listRequirement.push(
      this.getItemRequirement("Espacio libre de disco duro", validaItem,
        this.validacionPcService.diskFree + "",
        "400 MB","4000 MB","MB"));
    this.speedTest = this.validacionPcService.speedTest;
    
    validaItem = this.validacionPcService.validScreenWidth();
    this.listRequirement.push(
      this.getItemRequirement("Resolución de pantalla - Ancho", validaItem,
        this.validacionPcService.screenWidth + "",
        "1280 px","1360 px","px"));

    validaItem = this.validacionPcService.validHeigth();
    this.listRequirement.push(
      this.getItemRequirement("Resolución de pantalla - Alto", validaItem,
        this.validacionPcService.screenWidth + "",
        "768 px","768 px","px"));
    this.speedTest = this.validacionPcService.speedTest;

    validaItem = this.validacionPcService.validSystemOperative();
    this.listRequirement.push(
      this.getItemRequirement("Sistema Operativo", validaItem,
        null, null, null, null, this.validacionPcService.messageSystemOp+""));
    this.speedTest = this.validacionPcService.speedTest;
    
  }

  public getItemRequirement(title:string , estadoValidacion:number, value:string , minimo:string, recomedado:string, 
      unidad:string, messageBajo: string = null){
    return {
      title: title,
      valid: estadoValidacion,
      value: value,
      message: estadoValidacion == ESTADO_VALID_CPU.BAJO ? ( messageBajo == null ?`No cumple, minimo ${minimo} y tiene ${value} ${unidad}` : messageBajo)
       : estadoValidacion == ESTADO_VALID_CPU.ACEPTABLE ? ` Cumple, aunque se recomienda ${recomedado} y tiene ${value} ${unidad}`:`Cumple`,
    }
  }
 
}

interface IRequirement {
  title: string,
  valid: number,
  value: String,
  message: string,
}